import '../../assets/css/home.css';

import { Component } from 'react';
import {navigateTo, isDesktop} from "../../lib/helper";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

class Home extends Component{
	render() {
		let { window_width, asset_logo, asset_home_app } = this.props.appReducer;
		return (
			<div data-v-b0e45e8c="" id="mainContent">
				<div data-v-b0e45e8c="" className="boxContent">
					<div data-v-5954443c="" data-v-b0e45e8c="" className="homepage">
						<section data-v-5954443c="" className="backgroundImg profitabilityon">
							<div data-v-5954443c="" className="boxContent">
								<div data-v-5954443c="" className="container h-100">
									<div data-v-5954443c="" className="row h-100">
										<div data-v-5954443c="" className="col-lg-4 col6Landscape">
											<div data-v-5954443c=""
												 className=" d-flex flex-column justify-content-center h-100 pr-5 pr-0Landscape">
												<p data-v-5954443c=""
												   className="wbo-title titleLarge font-30m">Thịnh
													vượng trong tầm tay</p>
												<p data-v-5954443c=""
												   className="font-18 color-white-50 font-16m">Dễ
													dàng giao dịch và gia tăng tài sản trong tích tắc</p> <a
												data-v-5954443c="" href="#" onClick={navigateTo('trading').bind(this)}
												className="button wbtn height-60 btn-large btn-radius font-20 w-75 w-100l font-16m">Bắt đầu giao dịch</a></div>
										</div>
										<div data-v-5954443c=""
											 className="col-lg-6  col6Landscape offset-lg-2">
											<div data-v-5954443c=""
												 className="d-flex align-items-center h-100">
												<div data-v-5954443c=""
													 style={{ backgroundImage: `url(${asset_home_app})` }}
													 className="backgroundImg contain backgroundChart" />
											</div>
										</div>
									</div>
								</div>
							</div>
							<div data-v-5954443c="" className="backgroundB">
								<div data-v-5954443c="" className="backgroundImg backgroundBridge" />
							</div>
						</section>
						<section data-v-5954443c="" className="theFeatures">
							<div data-v-5954443c="" className="container"><p data-v-5954443c=""
																			 className="wbo-title titleLarge mb-4">Các
								tính
								năng của DIGINEX </p>
								<div data-v-5954443c="" className="row">
									<div data-v-5954443c="" className="col-lg-3 col-6">
										<div data-v-5954443c=""
											 className="backgroundImg background-1 mb30pc mb16mobile">
											<div data-v-5954443c="" className="contentFeature"><p
												data-v-5954443c=""
												className="wbo-title titleSmall">
												Các công cụ giao dịch chuyên nghiệp</p>
												<p data-v-5954443c="" className="text-elips-f14-4l">Nhanh
													chóng có được
													cái nhìn sâu sắc về biến động thị trường. Ra quyết định
													chính
													xác và kiếm lời trong phút chốc.</p></div>
										</div>
										<div data-v-5954443c="" className="backgroundImg background-2">
											<div data-v-5954443c="" className="contentFeature"><p
												data-v-5954443c=""
												className="wbo-title titleSmall">
												Demo không giới hạn</p>
												<p data-v-5954443c="" className="text-elips-f14-4l">Bạn luôn
													có thể cải
													thiện kỹ năng giao dịch của mình trên tài khoản demo và
													kiếm
													tiền sau khi hoàn thiện chiến lược của mình.</p></div>
										</div>
									</div>
									<div data-v-5954443c="" className="col-lg-3 col-6">
										<div data-v-5954443c="" className="backgroundImg background-3">
											<div data-v-5954443c="" className="contentFeature positionTop">
												<p
													data-v-5954443c="" className="wbo-title titleSmall">Hợp
													đồng thông
													minh trên Blockchain</p>
												<p data-v-5954443c="">Sử dụng Hợp đồng thông minh trên
													Blockchain,
													chúng tôi tạo ra một môi trường an toàn và minh bạch để
													giao
													dịch và bảo vệ tài sản của bạn.</p></div>
										</div>
									</div>
									<div data-v-5954443c="" className="col-lg-6">
										<div data-v-5954443c=""
											 style={{ marginTop: isDesktop() ? '' : '1rem' }}
											 className="backgroundImg background-4 mb30pc mb16mobile">
											<div data-v-5954443c="" className="contentFeature"><p
												data-v-5954443c=""
												className="wbo-title titleSmall">
												Thu nhập không giới hạn</p>
												<p data-v-5954443c="">Chương trình khuyến mãi và tiếp thị
													liên kết
													sáng tạo giúp bạn kiếm tiền ngay cả khi đang ngủ.</p>
											</div>
										</div>
										<div data-v-5954443c="" className="backgroundImg background-5">
											<div data-v-5954443c="" className="contentFeature"><p
												data-v-5954443c=""
												className="wbo-title titleSmall">
												Sử dụng nhiều loại Tiền và Tài sản</p>
												<p data-v-5954443c="">Gửi tiền và rút tiền nhanh chóng với
													nhiều tùy
													chọn thanh toán: ETH, BTC, WIN và nhiều loại tiền mã hóa
													khác
													nhau.</p></div>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section data-v-5954443c="" className="platform">
							<div data-v-5954443c="" className="container h-100">
								<div data-v-5954443c="" className="row h-100">
									<div data-v-5954443c="" className="col-lg-5 mb-lg-0 mb-3">
										<div data-v-5954443c=""
											 className=" d-flex flex-column justify-content-center align-items-lg-start align-items-center h-100 pr-lg-5">
											<p data-v-5954443c="" className="wbo-title titleLarge">Tham gia
												cùng chúng
												tôi để trở thành một Nhà Giao dịch theo Khung thời gian
												thành công
												ngay hôm nay!</p>
											<p data-v-5954443c="" className="font-18 color-white-50">Giao
												dịch theo
												Khung thời gian là một công cụ tài chính mang tính cách mạng
												giúp
												bạn dự báo xu hướng tỷ giá các cặp tiền và kiếm lợi nhuận.
												Bạn sẽ
												đưa ra dự đoán về việc giá của một tài sản sẽ tăng hay giảm
												trong
												một khoảng thời gian nhất định. Nếu dự đoán chính xác, bạn
												sẽ kiếm
												được tới 95% số tiền giao dịch của mình.</p> <a
											data-v-5954443c=""
											href="#" onClick={navigateTo('trading').bind(this)}
											className="button wbtn height-60 btn-large btn-radius font-20 w-75 mb-lg-0 mb-4 font-16m">Bắt
											đầu giao dịch</a></div>
									</div>
									<div data-v-5954443c="" className="col-lg-6 offset-lg-1">
										<div data-v-5954443c="" className="row align-items-center h-100">
											<div data-v-5954443c="" className="col-6 mb30pc mb16px">
												<div data-v-5954443c=""
													 className=" platformBox d-flex flex-column">
													<div data-v-5954443c="" className="topContent mb-5"><img
														data-v-5954443c=""
														src="data:image/svg+xml;base64,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"
														alt="" /></div>
													<div data-v-5954443c="" className="bottomContent"><p
														data-v-5954443c=""
														className="wbo-title titleSmall color-white font-weight-700 text-uppercase">
														Nạp rút nhanh chóng</p></div>
												</div>
											</div>
											<div data-v-5954443c="" className="col-6 mb30pc mb16px">
												<div data-v-5954443c=""
													 className=" platformBox d-flex flex-column">
													<div data-v-5954443c="" className="topContent mb-5"><img
														data-v-5954443c=""
														src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMyIgaGVpZ2h0PSIzMyIgdmlld0JveD0iMCAwIDMzIDMzIj4KICA8ZyBpZD0iam9pbnQtYWNjb3VudCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTEpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzI4OTg1IiBkYXRhLW5hbWU9IlBhdGggMjg5ODUiIGQ9Ik00Ni43MjYsOC40NTJhMy43MjYsMy43MjYsMCwxLDEsMy43MjYtMy43MjZBMy43MjYsMy43MjYsMCwwLDEsNDYuNzI2LDguNDUyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5LjY0NSAwKSIgZmlsbD0iIzIxNzdmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjg5ODYiIGRhdGEtbmFtZT0iUGF0aCAyODk4NiIgZD0iTTEwLjcyNiw4LjQ1MmEzLjcyNiwzLjcyNiwwLDEsMSwzLjcyNi0zLjcyNkEzLjcyNiwzLjcyNiwwLDAsMSwxMC43MjYsOC40NTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi44MDYpIiBmaWxsPSIjMjE3N2ZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yODk4NyIgZGF0YS1uYW1lPSJQYXRoIDI4OTg3IiBkPSJNNDkuNTMxLDIwLjQ0OGExMS42MTksMTEuNjE5LDAsMCwwLTExLjIzNCwwQTIuNjc1LDIuNjc1LDAsMCwwLDM3LDIyLjczMnYyLjUwNWE5LjYxLDkuNjEsMCwwLDEsNS42MjMsNC40MDdoNy42ODRhLjUzMi41MzIsMCwwLDAsLjUzMi0uNTMyVjIyLjc0MkEyLjY3OCwyLjY3OCwwLDAsMCw0OS41MzEsMjAuNDQ4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2LjgzOSAtOC40MTgpIiBmaWxsPSIjMjE3N2ZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yODk4OCIgZGF0YS1uYW1lPSJQYXRoIDI4OTg4IiBkPSJNMTQuODM5LDI1LjIzN1YyMi43MzFhMi42NzYsMi42NzYsMCwwLDAtMS4zLTIuMjg5QTEwLjg1MywxMC44NTMsMCwwLDAsNy45MTksMTlhMTAuOTQsMTAuOTQsMCwwLDAtNS42MTIsMS40NUEyLjY3NywyLjY3NywwLDAsMCwxLDIyLjc0MnY2LjM2OWEuNTMyLjUzMiwwLDAsMCwuNTMyLjUzMkg5LjIxNkE5LjYxLDkuNjEsMCwwLDEsMTQuODM5LDI1LjIzN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTguNDE4KSIgZmlsbD0iIzIxNzdmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMjg5ODkiIGRhdGEtbmFtZT0iUGF0aCAyODk4OSIgZD0iTTI0Ljk4NCwzM2E3Ljk4NCw3Ljk4NCwwLDEsMCw3Ljk4NCw3Ljk4NEE3Ljk4NCw3Ljk4NCwwLDAsMCwyNC45ODQsMzNabTMuMDM4LDguMzZMMjUuMzYsNDQuMDIxYS41MzIuNTMyLDAsMCwxLS43NTMsMEwyMS45NDYsNDEuMzZhLjUzMi41MzIsMCwwLDEsMC0uNzUzbDIuNjYxLTIuNjYxYS41MzIuNTMyLDAsMCwxLC43NTMsMGwyLjY2MSwyLjY2MUEuNTMyLjUzMiwwLDAsMSwyOC4wMjEsNDEuMzZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNy40ODQgLTE0Ljk2OCkiIGZpbGw9IiNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo="
														alt="" /></div>
													<div data-v-5954443c="" className="bottomContent"><p
														data-v-5954443c=""
														className="wbo-title titleSmall color-white font-weight-700 text-uppercase">
														Nền tảng tiên tiến và đáng tin cậy</p></div>
												</div>
											</div>
											<div data-v-5954443c="" className="col-6 mb30pc mb16px">
												<div data-v-5954443c=""
													 className=" platformBox d-flex flex-column">
													<div data-v-5954443c="" className="topContent mb-5"><img
														data-v-5954443c=""
														src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMyIgaGVpZ2h0PSIzMi43NTMiIHZpZXdCb3g9IjAgMCAzMyAzMi43NTMiPgogIDxnIGlkPSJjb252ZXJzaW9uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMS4xNzIpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzI4OTkwIiBkYXRhLW5hbWU9IlBhdGggMjg5OTAiIGQ9Ik0zMi41NjUsMTQuNjc5SDF2LTIuODdIMjkuMUwyMC40OTIsMy4ybDIuMDMtMi4wMjlMMzMuNTgsMTIuMjNhMS40MzQsMS40MzQsMCwwLDEtMS4wMTQsMi40NDlaIiBmaWxsPSIjMjE3N2ZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yODk5MSIgZGF0YS1uYW1lPSJQYXRoIDI4OTkxIiBkPSJNMTIuNDc4LDQxLjUwNywxLjQyLDMwLjQ0OUExLjQzNCwxLjQzNCwwLDAsMSwyLjQzNSwyOEgzNHYyLjg3SDUuOWw4LjYwOSw4LjYwOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTcuNTgyKSIgZmlsbD0iI2ZmZiIvPgogIDwvZz4KPC9zdmc+Cg=="
														alt="" /></div>
													<div data-v-5954443c="" className="bottomContent"><p
														data-v-5954443c=""
														className="wbo-title titleSmall color-white font-weight-700 text-uppercase">
														Mua và Bán Tức thời</p></div>
												</div>
											</div>
											<div data-v-5954443c="" className="col-6 mb30pc mb16px">
												<div data-v-5954443c=""
													 className=" platformBox d-flex flex-column">
													<div data-v-5954443c="" className="topContent mb-5"><img
														data-v-5954443c=""
														src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzNS43NyIgdmlld0JveD0iMCAwIDMwIDM1Ljc3Ij4KICA8ZyBpZD0iR3JvdXBfMTI4OTAiIGRhdGEtbmFtZT0iR3JvdXAgMTI4OTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05OTIgLTE2MTUuOTk5KSI+CiAgICA8ZyBpZD0iRWxsaXBzZV8xMzYwIiBkYXRhLW5hbWU9IkVsbGlwc2UgMTM2MCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTk2IDE2MjQpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMSI+CiAgICAgIDxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjExIiBzdHJva2U9Im5vbmUiLz4KICAgICAgPGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iMTAuNSIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPGcgaWQ9InByaXZhY3kiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk4OSAxNjE1KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzI4OTkyIiBkYXRhLW5hbWU9IlBhdGggMjg5OTIiIGQ9Ik0xNi4zMDgsMTFBMi4zMDgsMi4zMDgsMCwwLDAsMTQsMTMuMzA4djIuMzA4aDQuNjE1VjEzLjMwOEEyLjMwOCwyLjMwOCwwLDAsMCwxNi4zMDgsMTFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjY5MiAxLjUzOSkiIGZpbGw9IiMyMTc3ZmYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjg5OTMiIGRhdGEtbmFtZT0iUGF0aCAyODk5MyIgZD0iTTMyLjEyNyw0LjUsMTguMjgsMS4wMzVhMS4xMjYsMS4xMjYsMCwwLDAtLjU2MSwwTDMuODczLDQuNUExLjE1NCwxLjE1NCwwLDAsMCwzLDUuNjE1VjIxLjc2OWExNSwxNSwwLDAsMCwzMCwwVjUuNjE1QTEuMTU0LDEuMTU0LDAsMCwwLDMyLjEyNyw0LjVabS03LjIsMjEuODg4YTEuMTU0LDEuMTU0LDAsMCwxLTEuMTU0LDEuMTU0SDEyLjIzMWExLjE1NCwxLjE1NCwwLDAsMS0xLjE1NC0xLjE1NFYxOC4zMDhhMS4xNTQsMS4xNTQsMCwwLDEsMS4xNTQtMS4xNTRoMS4xNTRWMTQuODQ2YTQuNjE1LDQuNjE1LDAsMSwxLDkuMjMxLDB2Mi4zMDhoMS4xNTRhMS4xNTQsMS4xNTQsMCwwLDEsMS4xNTQsMS4xNTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjMjE3N2ZmIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"
														alt="" /></div>
													<div data-v-5954443c="" className="bottomContent"><p
														data-v-5954443c=""
														className="wbo-title titleSmall color-white font-weight-700 text-uppercase">
														Thanh khoản cao</p></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</section>
						<section data-v-5954443c="" className="peopleSay">
							<div data-v-5954443c="" className="container position-relative"><p
								data-v-5954443c=""
								className="wbo-title titleLarge mb-4">
								Mọi người nhận xét về chúng tôi?</p>
								<div data-v-5954443c="" className="row">
									<div data-v-5954443c="" className="col-lg-7">
										<div data-v-5954443c="" className="sayBox topBox">
											<div data-v-5954443c=""
												 className="swiper-container peopleSaySwiper swiper-container-fade swiper-container-vertical">
												<div data-v-5954443c="" className="swiper-wrapper">
													<div data-v-5954443c=""
														 className="swiper-slide swiper-slide-active"
														 style={{ height: '239px', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
														<div data-v-5954443c=""
															 className="contentItem top-left">
															<div data-v-5954443c="" className="textBox"><p
																data-v-5954443c=""
																className="wbo-title titleSmall color-white text-uppercase font-weight-700">
																Mahmoud Baghagho</p>
																<p data-v-5954443c=""
																   className="color-white-50 text-elips-f14-4l">“Mình
																	rất khuyến khích giao dịch trên DIGINEX
																	nhờ trải
																	nghiệm tuyệt vời. Việc giao dịch rất đơn
																	giản và
																	dễ dàng thao tác chỉ với vài bước. Nền
																	tảng của
																	DIGINEX hỗ trợ tất cả các loại tiền mã
																	hóa phổ
																	biến và quá trình nạp rút tiền cũng diễn
																	ra rất
																	suôn sẻ!”</p></div>
															<div data-v-5954443c="" className="avatar">
																<div data-v-5954443c=""
																	 className=" backgroundImg backgroundTopLeft" />
															</div>
														</div>
													</div>
												</div>
												<span className="swiper-notification" aria-live="assertive"
													  aria-atomic="true" /></div>
										</div>
										<div data-v-5954443c="" className="sayBox bottomBox">
											<div data-v-5954443c=""
												 className="swiper-container peopleSaySwiper swiper-container-fade swiper-container-vertical">
												<div data-v-5954443c="" className="swiper-wrapper">
													<div data-v-5954443c=""
														 className="swiper-slide swiper-slide-active"
														 style={{ height: '239px', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
														<div data-v-5954443c=""
															 className="contentItem bottom-left">
															<div data-v-5954443c="" className="avatar">
																<div data-v-5954443c=""
																	 className=" backgroundImg backgroundBottomLeft" />
															</div>
															<div data-v-5954443c="" className="textBox"><p
																data-v-5954443c=""
																className="wbo-title titleSmall color-white text-uppercase font-weight-700">
																Ernest Isley</p>
																<p data-v-5954443c=""
																   className="color-white-50 text-elips-f14-4l">“Thật
																	đáng ngạc nhiên, tôi từng là một nhà đầu
																	tư ở
																	Phố Wall. Và tôi không bao giờ thấy bất
																	cứ điều
																	gì như thế này trong khoảng 10 năm của
																	tôi tại
																	công ty. Các đồng nghiệp của tôi đều
																	nghĩ rằng
																	tôi bị điên khi rời khỏi công ty để đầu
																	tư với
																	nền tảng DIGINEX toàn thời gian. Tuy
																	nhiên,
																	nền tảng mang lại lợi nhuận $55/ngày, và
																	tất cả
																	các đồng nghiệp của tôi hiện đang BẮT
																	ĐẦU xin
																	tôi hướng dẫn họ tham gia.”</p></div>
														</div>
													</div>
												</div>
												<span className="swiper-notification" aria-live="assertive"
													  aria-atomic="true"/>
											</div>
										</div>
									</div>
									<div data-v-5954443c="" className="col-lg-5 mt1-landscape">
										<div data-v-5954443c="" className="sayBox rightBox">
											<div data-v-5954443c=""
												 className="swiper-container peopleSaySwiper swiper-container-fade swiper-container-vertical">
												<div data-v-5954443c="" className="swiper-wrapper">
													<div data-v-5954443c=""
														 className="swiper-slide swiper-slide-active"
														 style={{ height: '495px', opacity: 1, transform: 'translate3d(0px, 0px, 0px)' }}>
														<div data-v-5954443c=""
															 className="contentItem right">
															<div data-v-5954443c="" className="avatar">
																<div data-v-5954443c=""
																	 className=" backgroundImg backgroundRight"/>
															</div>
															<div data-v-5954443c="" className="textBox"><p
																data-v-5954443c=""
																className="wbo-title titleSmall color-white text-uppercase font-weight-700">
																Judith Taylor</p>
																<p data-v-5954443c=""
																   className="color-white-50 text-elips-f14-4l">“Cuối
																	cùng tôi cũng có thể kiếm được lợi nhuận
																	từ việc
																	giao dịch tiền mã hóa. Ngoài ra, tôi
																	không còn
																	phải theo dõi các tài khoản trên
																	Tradingview để
																	học hỏi cách giao dịch. DIGINEX đã cho
																	phép tôi
																	có nhiều thời gian hơn nhờ vào lợi nhuận
																	khi
																	giao dịch”.</p></div>
														</div>
													</div>
												</div>
												<span className="swiper-notification" aria-live="assertive"
													  aria-atomic="true" /></div>
										</div>
									</div>
								</div>
								<div data-v-5954443c="" className="groupButton text-center py-4"><a
									data-v-5954443c=""
									href="#" onClick={navigateTo('trading').bind(this)}
									className="button wbtn height-60 btn-large btn-radius font-20 w-25 font-16m">Bắt
									đầu giao dịch</a></div>
							</div>
						</section>
						<div data-v-24978cff="" data-v-5954443c="" className="footerFAQs">
							<div data-v-24978cff="" className="container position-relative">
								<div data-v-24978cff="" className="blockRow py-5">
									<div data-v-24978cff="" className="block logo"><p data-v-24978cff="">
										<img
											data-v-24978cff="" width="208" height="35"
											src={asset_logo}
											alt="" /></p>
										<p data-v-24978cff="" className="font-12">© 2020 DIGINEX All rights
											reserved.</p></div>
									<div data-v-24978cff="" className="block"><p data-v-24978cff="">Risk
										Warning:
										Trading and investing in digital options involves significant level
										of risk
										and is not suitable and/or appropriate for all clients. Please make
										sure you
										carefully consider your investment objectives, level of experience
										and risk
										appetite before buying or selling any digital asset. You should be
										aware of
										and fully understand all the risks associated with trading and
										investing in
										digital assets, you should not invest funds you cannot afford to
										lose. You
										are granted limited non-exclusive rights to use the IP contained in
										this
										site for personal, non-commercial, non-transferable use only in
										relation to
										the services offered on the site</p></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		appReducer: state.appReducer
	};
}

export default connect(mapStateToProps)(withRouter(Home));
